import { Controller } from '@hotwired/stimulus'
import Util from '../../lib/util'

export default class extends Controller {
  static targets = ['carousel', 'preview', 'previewTitle', 'websiteImage', 'invitationImage', 'link', 'prev', 'next']

  connect () {
    if (Util.overflowedX(this.carouselTarget.lastElementChild)) { this.nextTarget.classList.remove('hidden') }
  }

  next () {
    Util.scrollElement(this.carouselTarget, { top: 0, left: 232 * 4 }, false)
    this.prevTarget.classList.remove('hidden')

    const c = this.carouselTarget.lastElementChild
    const i = c.lastElementChild

    if (this.carouselTarget.scrollLeft + c.clientWidth >= i.offsetLeft + i.clientWidth) this.nextTarget.classList.add('hidden')
  }

  prev () {
    Util.scrollElement(this.carouselTarget, { top: 0, left: -232 * 4 }, false)
    this.nextTarget.classList.remove('hidden')
    if (this.carouselTarget.scrollLeft === 0) this.prevTarget.classList.add('hidden')
  }
}
